import React from 'react';
import PropTypes from 'prop-types';

export function Player({ isAnimationInProgress, onPlayPauseClick, onNextClick, onPrevClick }) {
  return (
    <div className="player d-flex align-items-center justify-content-center mb-1" style={{ minHeight: '60px' }}>
      <button type="button" onClick={onPrevClick} className="arrow-btn p-0" aria-label="Backward">
        <span className="size-24 icon-backward21 text-gray-darker" aria-hidden />
      </button>
      <button
        type="button"
        className="play-btn bg-white size-24 text-primary-darker mx-1_5 d-flex align-items-center justify-content-center"
        onClick={onPlayPauseClick}
        aria-label={isAnimationInProgress ? 'Pause' : 'Play'}
      >
        {isAnimationInProgress ? (
          <span className="icon-pause21" aria-hidden />
        ) : (
          <span className="icon-play41" aria-hidden />
        )}
      </button>
      <button type="button" onClick={onNextClick} className="arrow-btn p-0" aria-label="Forward">
        <span className="size-24 icon-forward31 text-gray-darker" aria-hidden />
      </button>
    </div>
  );
}

Player.propTypes = {
  isAnimationInProgress: PropTypes.bool.isRequired,
  onPlayPauseClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
};
